export default [
	"Overall",
	"Games", 
	"Business", 
	"Weather", 
	"Utilities", 
	"Travel", 
	"Sports", 
	"Social Networking", 
	"Reference", 
	"Productivity", 
	"Photo & Video", 
	"News", 
	"Navigation", 
	"Music", 
	"Lifestyle", 
	"Health & Fitness", 
	"Finance", 
	"Entertainment", 
	"Education", 
	"Book", 
	"Medical", 
	"Magazines & Newspapers", 
	"Catalogs", 
	"Food & Drink", 
	"Shopping", 
	"Stickers", 
	"Action", 
	"Adventure", 
	"Arcade", 
	"Board", 
	"Card", 
	"Casino", 
	"Dice", 
	"Educational", 
	"Family", 
	"Music", 
	"Puzzle", 
	"Racing", 
	"Role Playing", 
	"Simulation", 
	"Sports", 
	"Strategy", 
	"Trivia", 
	"Word", 
	"News & Politics", 
	"Fashion & Style", 
	"Home & Garden", 
	"Outdoors & Nature", 
	"Sports & Leisure", 
	"Automotive", 
	"Arts & Photography", 
	"Brides & Weddings", 
	"Business & Investing", 
	"Children's Magazines", 
	"Computers & Internet", 
	"Cooking, Food & Drink", 
	"Crafts & Hobbies", 
	"Electronics & Audio", 
	"Entertainment", 
	"Health, Mind & Body", 
	"History", 
	"Literary Magazines & Journals", 
	"Men's Interest", 
	"Movies & Music", 
	"Parenting & Family", 
	"Pets", 
	"Professional & Trade", 
	"Regional News", 
	"Science", 
	"Teens", 
	"Travel & Regional", 
	"Women's Interest"
]